import type { AppFlags } from "@calcom/features/flags/config";
import { trpc } from "@calcom/trpc/react";

const initialData: AppFlags = {
  "calendar-cache": false,
  emails: false,
  webhooks: false,
  "email-verification": false,
  "disable-signup": false,
  "signup-requires-plan": false,
  "organizer-request-email-v2": false,
  "delegation-credential": false,
  "restriction-schedule": false,
  "calendar-subscription-cache": false,
  "calendar-subscription-sync": false,
  "onboarding-v3": false,
  "bookings-v3": false,
  "booking-audit": false,
  "signup-watchlist-review": false,
  "sink-shortener": false,
  "secretary-delegation": false,
  waitlist: false,
  "booking-reminders": false,
  "noshow-stats": false,
  "inline-payment": false,
  "whatsapp-notifications": false,
  "review-requests": false,
  "developer-tools": false,
};

export function useFlags(): Partial<AppFlags> {
  const query = trpc.viewer.features.map.useQuery();
  return query.data ?? initialData;
}
